<template>
  <div class="wcdiv wcpage" style="width: 595.3pt; height: 841.9pt">
    <div class="wcdiv" style="left: 28.35pt; top: 28.35pt">
      <div
        class="wcdiv"
        style="
          left: -0.05pt;
          top: -0.05pt;
          width: 79.9pt;
          height: 20.7pt;
          background-color: #d8d8d8;
          border: solid 0.1pt #d8d8d8;
        "
      >
        <br />
      </div>
      <div
        class="wcdiv"
        style="
          left: 79.95pt;
          top: -0.05pt;
          width: 163.9pt;
          height: 20.7pt;
          background-color: #d8d8d8;
          border: solid 0.1pt #d8d8d8;
        "
      >
        <br />
      </div>
      <span
        class="wcspan wctext002"
        style="font-size: 16pt; left: 0pt; top: 1.61pt"
        >第六部份：簡式營養風險評估調查</span
      >
      <span
        class="wcspan wctext005"
        style="font-size: 14pt; color: #004990; left: 244pt; top: 1.75pt"
        >Mini Nutritional Assessment&nbsp;</span
      >
      <span
        class="wcspan wctext003"
        style="font-size: 14pt; color: #004990; left: 420.61pt; top: 1.75pt"
        >MNA</span
      >
      <span
        class="wcspan wctext003"
        style="font-size: 9pt; color: #004990; left: 452.5pt; top: 2.03pt"
        >&reg;</span
      >
      <div class="wcdiv" style="left: 2.05pt; top: 20.8pt">
        <span class="wcspan wctext002" style="left: 0pt; top: 1.71pt"
          >(注意:個案</span
        >
        <span class="wcspan wctext002" style="left: 63.5pt; top: 1.71pt"
          >3</span
        >
        <span class="wcspan wctext002" style="left: 72.5pt; top: 1.71pt"
          >個月內</span
        >
        <span class="wcspan wctext002" style="left: 109pt; top: 1.71pt"
          >因重大事件不適宜評估，如刻意減重、車禍&hellip;等)</span
        >
        <span
          class="wcspan wctext004"
          style="font-size: 11pt; left: 367pt; top: 1.51pt"
          >&nbsp;</span
        >
        <div
          class="wcdiv"
          style="
            left: 63pt;
            top: 0.5pt;
            width: 0pt;
            height: 15.6pt;
            border-left: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: 108.5pt;
            top: 0.5pt;
            width: 0pt;
            height: 15.6pt;
            border-left: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: 63pt;
            top: 0pt;
            width: 46pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: 63pt;
            top: 16.1pt;
            width: 46pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: 0pt;
            top: 13.43pt;
            width: 367pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
      </div>
      <div class="wcdiv" style="left: 23.5pt; top: 44.4pt">
        <div class="wcdiv" style="clip: rect(0pt, 127.75pt, 17.45pt, 0pt)">
          <div class="wcdiv" style="left: 2.05pt">
            <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
              >姓名: {{ person.姓名 }}</span
            >
          </div>
        </div>
        <div
          class="wcdiv"
          style="left: 127.75pt; clip: rect(0pt, 149.6pt, 17.45pt, 0pt)"
        >
          <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
            >性別: {{ 性別 }}</span
          >
        </div>
        <div
          class="wcdiv"
          style="left: 277.35pt; clip: rect(0pt, 127pt, 17.45pt, 0pt)"
        >
          <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
            >無法評估原因：</span
          >
        </div>
        <div class="wcdiv" style="top: 16.45pt">
          <div class="wcdiv" style="clip: rect(0.75pt, 127.75pt, 18.2pt, 0pt)">
            <div class="wcdiv" style="left: 2.05pt; top: 0.75pt">
              <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
                >年齡: {{ age }}</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 127.75pt; clip: rect(0.75pt, 149.6pt, 18.2pt, 0pt)"
          >
            <div class="wcdiv" style="top: 0.75pt">
              <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
                >體重, 公斤, kg:</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 277.35pt; clip: rect(0.75pt, 127pt, 18.2pt, 0pt)"
          >
            <div class="wcdiv" style="top: 0.75pt">
              <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
                >身高,公分, cm:</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 404.35pt; clip: rect(0.75pt, 106.85pt, 18.2pt, 0pt)"
          >
            <div class="wcdiv" style="top: 0.75pt">
              <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
                >日期:</span
              >
            </div>
          </div>
        </div>
        <div
          class="wcdiv"
          style="
            left: 0pt;
            top: 16.45pt;
            width: 511.2pt;
            height: 0pt;
            border-top: solid 0.75pt #091c5a;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: 0pt;
            top: 33.65pt;
            width: 511.2pt;
            height: 0pt;
            border-top: solid 0.75pt #091c5a;
          "
        >
          <br />
        </div>
      </div>
      <div class="wcdiv" style="left: 24.25pt; top: 78.8pt">
        <span class="wcspan wctext001" style="left: 0pt; top: 2.41pt"
          >請於方格內填上適當的分數，將分數加總以得出最後篩選分數。</span
        >
      </div>
      <div class="wcdiv" style="left: 24.5pt; top: 96.8pt">
        <div class="wcdiv" style="clip: rect(0.5pt, 487.15pt, 19.5pt, 0.25pt)">
          <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
            <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
              >篩選</span
            >
          </div>
        </div>
        <div class="wcdiv" style="top: 18.5pt">
          <div
            class="wcdiv"
            style="clip: rect(0.5pt, 487.15pt, 64.89pt, 0.25pt)"
          >
            <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
              <span class="wcspan wctext002" style="left: 0pt; top: 1.71pt"
                >A 過去</span
              >
              <span class="wcspan wctext002" style="left: 36.5pt; top: 1.71pt"
                >三個月內</span
              >
              <span class="wcspan wctext002" style="left: 85pt; top: 1.71pt"
                >有沒有因為食慾不振、消化問題、咀嚼或吞嚥困難而減少食量?</span
              >
              <div
                class="wcdiv"
                style="
                  left: 36pt;
                  top: 0.5pt;
                  width: 0pt;
                  height: 15.6pt;
                  border-left: solid 0.75pt #000000;
                "
              >
                <br />
              </div>
              <div
                class="wcdiv"
                style="
                  left: 84.5pt;
                  top: 0.5pt;
                  width: 0pt;
                  height: 15.6pt;
                  border-left: solid 0.75pt #000000;
                "
              >
                <br />
              </div>
              <div
                class="wcdiv"
                style="
                  left: 36pt;
                  top: 0pt;
                  width: 49pt;
                  height: 0pt;
                  border-top: solid 0.75pt #000000;
                "
              >
                <br />
              </div>
              <div
                class="wcdiv"
                style="
                  left: 36pt;
                  top: 16.1pt;
                  width: 49pt;
                  height: 0pt;
                  border-top: solid 0.75pt #000000;
                "
              >
                <br />
              </div>
            </div>
            <div class="wcdiv" style="left: 16.8pt; top: 17.1pt">
              <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
                >0 = 食量嚴重減少(如一個便當本來吃的完，現在只吃</span
              >
              <span class="wcspan wctext001" style="left: 285pt; top: 1.21pt"
                >1/2</span
              >
              <span class="wcspan wctext001" style="left: 306pt; top: 1.21pt"
                >為少很多)</span
              >
            </div>
            <div class="wcdiv" style="left: 16.8pt; top: 32.7pt">
              <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
                >1 = 食量中度減少(如一個便當本來吃的完，現在只吃</span
              >
              <span class="wcspan wctext001" style="left: 285pt; top: 1.21pt"
                >2/3</span
              >
              <span class="wcspan wctext001" style="left: 306pt; top: 1.21pt"
                >為少一點)</span
              >
            </div>
            <div class="wcdiv" style="left: 16.8pt; top: 48.29pt">
              <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
                >2 = 食量沒有改變</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 487.4pt; clip: rect(0.5pt, 26.2pt, 64.89pt, 0.25pt)"
          >
            <div class="wcdiv" style="left: -3pt; top: 0.5pt">
              <span class="wcspan wctext001" style="left: 1.83pt; top: 47.8pt">
                {{
                  ifet(
                    "A 過去三個月內有沒有因為食慾不振、消化問題、咀嚼或吞嚥困難而減少食量?",
                    "0 .食量嚴重減少(如一個便當本來吃的完，現在只吃1/2為少很多)",
                    "0"
                  )
                }}
                {{
                  ifet(
                    "A 過去三個月內有沒有因為食慾不振、消化問題、咀嚼或吞嚥困難而減少食量?",
                    "1.食量中度減少 (如一個便當本來吃的完，現在只吃2/3為少一點)",
                    "1"
                  )
                }}
                {{
                  ifet(
                    "A 過去三個月內有沒有因為食慾不振、消化問題、咀嚼或吞嚥困難而減少食量?",
                    "2.食量沒有改變",
                    "2"
                  )
                }}
              </span>
            </div>
          </div>
        </div>
        <div class="wcdiv" style="top: 82.39pt">
          <div
            class="wcdiv"
            style="clip: rect(0.5pt, 487.15pt, 80.49pt, 0.25pt)"
          >
            <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
              <span class="wcspan wctext002" style="left: 0pt; top: 1.71pt"
                >B 過去</span
              >
              <span class="wcspan wctext002" style="left: 36.5pt; top: 1.71pt"
                >三個月內</span
              >
              <span class="wcspan wctext002" style="left: 85pt; top: 1.71pt"
                >體重下降的情況</span
              >
              <div
                class="wcdiv"
                style="
                  left: 36pt;
                  top: 0.5pt;
                  width: 0pt;
                  height: 15.6pt;
                  border-left: solid 0.75pt #000000;
                "
              >
                <br />
              </div>
              <div
                class="wcdiv"
                style="
                  left: 84.5pt;
                  top: 0.5pt;
                  width: 0pt;
                  height: 15.6pt;
                  border-left: solid 0.75pt #000000;
                "
              >
                <br />
              </div>
              <div
                class="wcdiv"
                style="
                  left: 36pt;
                  top: 0pt;
                  width: 49pt;
                  height: 0pt;
                  border-top: solid 0.75pt #000000;
                "
              >
                <br />
              </div>
              <div
                class="wcdiv"
                style="
                  left: 36pt;
                  top: 16.1pt;
                  width: 49pt;
                  height: 0pt;
                  border-top: solid 0.75pt #000000;
                "
              >
                <br />
              </div>
            </div>
            <div class="wcdiv" style="left: 16.8pt; top: 17.1pt">
              <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
                >0 = 體重下降大於</span
              >
              <span class="wcspan wctext001" style="left: 99pt; top: 1.21pt"
                >3</span
              >
              <span class="wcspan wctext001" style="left: 108pt; top: 1.21pt"
                >公斤 (6.6</span
              >
              <span class="wcspan wctext001" style="left: 165pt; top: 1.21pt"
                >磅)</span
              >
            </div>
            <div class="wcdiv" style="left: 16.8pt; top: 32.7pt">
              <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
                >1 = 不知道</span
              >
            </div>
            <div class="wcdiv" style="left: 16.8pt; top: 48.29pt">
              <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
                >2 = 體重下降</span
              >
              <span class="wcspan wctext001" style="left: 75pt; top: 1.21pt"
                >1-3</span
              >
              <span class="wcspan wctext001" style="left: 96pt; top: 1.21pt"
                >公斤 (2.2-6.6</span
              >
              <span class="wcspan wctext001" style="left: 177pt; top: 1.21pt"
                >磅)</span
              >
            </div>
            <div class="wcdiv" style="left: 16.8pt; top: 63.89pt">
              <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
                >3 = 體重沒有下降</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 487.4pt; clip: rect(0.5pt, 26.2pt, 80.49pt, 0.25pt)"
          >
            <div class="wcdiv" style="left: -6pt; top: 0.5pt">
              <span class="wcspan wctext001" style="left: 1.83pt; top: 63.4pt">
                {{
                  ifet(
                    "B 過去三個月內體重下降的情況",
                    "0.體重下降大於3公斤 (6.6磅)",
                    "0"
                  )
                }}
                {{ ifet("B 過去三個月內體重下降的情況", "1.不知道", "1") }}
                {{
                  ifet(
                    "B 過去三個月內體重下降的情況",
                    "2.體重下降1-3公斤 (2.2-6.6磅)",
                    "2"
                  )
                }}
                {{
                  ifet("B 過去三個月內體重下降的情況", "3.體重沒有下降", "3")
                }}
              </span>
            </div>
          </div>
        </div>
        <div class="wcdiv" style="top: 161.88pt">
          <div
            class="wcdiv"
            style="clip: rect(0.5pt, 487.15pt, 63.89pt, 0.25pt)"
          >
            <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
              <span class="wcspan wctext002" style="left: 0pt; top: 1.21pt"
                >C 活動能力</span
              >
            </div>
            <div class="wcdiv" style="left: 16.8pt; top: 16.1pt">
              <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
                >0= 需長期臥床或坐輪椅</span
              >
            </div>
            <div class="wcdiv" style="left: 16.8pt; top: 31.7pt">
              <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
                >1= 可以下床或離開輪椅，但不能外出</span
              >
            </div>
            <div class="wcdiv" style="left: 16.8pt; top: 47.29pt">
              <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
                >2= 可以外出</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 487.4pt; clip: rect(0.5pt, 26.2pt, 63.89pt, 0.25pt)"
          >
            <div class="wcdiv" style="left: -3pt; top: 0.5pt">
              <span class="wcspan wctext001" style="left: 1.83pt; top: 46.8pt">
                {{ ifet("C 活動能力", "0.需長期臥床或坐輪椅", "0") }}
                {{
                  ifet("C 活動能力", "1.可以下床或離開輪椅，但不能外出", "1")
                }}
                {{ ifet("C 活動能力", "2.可以外出", "2") }}
              </span>
            </div>
          </div>
        </div>
        <div class="wcdiv" style="top: 224.77pt">
          <div
            class="wcdiv"
            style="clip: rect(0.5pt, 487.15pt, 49.29pt, 0.25pt)"
          >
            <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
              <span class="wcspan wctext002" style="left: 0pt; top: 1.71pt"
                >D 過去</span
              >
              <span class="wcspan wctext002" style="left: 36.5pt; top: 1.71pt"
                >三個月內</span
              >
              <span class="wcspan wctext002" style="left: 85pt; top: 1.71pt"
                >有沒有受到心理創傷或患上</span
              >
              <span class="wcspan wctext002" style="left: 229.5pt; top: 1.71pt"
                >急性疾病</span
              >
              <span class="wcspan wctext002" style="left: 278pt; top: 1.71pt"
                >?</span
              >
              <span class="wcspan wctext001" style="left: 284pt; top: 1.71pt"
                >(已預先排定之手術不算)</span
              >
              <div
                class="wcdiv"
                style="
                  left: 36pt;
                  top: 0.5pt;
                  width: 0pt;
                  height: 15.6pt;
                  border-left: solid 0.75pt #000000;
                "
              >
                <br />
              </div>
              <div
                class="wcdiv"
                style="
                  left: 84.5pt;
                  top: 0.5pt;
                  width: 0pt;
                  height: 15.6pt;
                  border-left: solid 0.75pt #000000;
                "
              >
                <br />
              </div>
              <div
                class="wcdiv"
                style="
                  left: 36pt;
                  top: 0pt;
                  width: 49pt;
                  height: 0pt;
                  border-top: solid 0.75pt #000000;
                "
              >
                <br />
              </div>
              <div
                class="wcdiv"
                style="
                  left: 36pt;
                  top: 16.1pt;
                  width: 49pt;
                  height: 0pt;
                  border-top: solid 0.75pt #000000;
                "
              >
                <br />
              </div>
              <div
                class="wcdiv"
                style="
                  left: 229pt;
                  top: 0.5pt;
                  width: 0pt;
                  height: 15.6pt;
                  border-left: solid 0.75pt #000000;
                "
              >
                <br />
              </div>
              <div
                class="wcdiv"
                style="
                  left: 277.5pt;
                  top: 0.5pt;
                  width: 0pt;
                  height: 15.6pt;
                  border-left: solid 0.75pt #000000;
                "
              >
                <br />
              </div>
              <div
                class="wcdiv"
                style="
                  left: 229pt;
                  top: 0pt;
                  width: 49pt;
                  height: 0pt;
                  border-top: solid 0.75pt #000000;
                "
              >
                <br />
              </div>
              <div
                class="wcdiv"
                style="
                  left: 229pt;
                  top: 16.1pt;
                  width: 49pt;
                  height: 0pt;
                  border-top: solid 0.75pt #000000;
                "
              >
                <br />
              </div>
            </div>
            <div class="wcdiv" style="left: 16.8pt; top: 17.1pt">
              <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
                >0 = 有</span
              >
            </div>
            <div class="wcdiv" style="left: 16.8pt; top: 32.7pt">
              <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
                >2 = 沒有(沒診所看病而去掛急診者，算沒有給</span
              >
              <span class="wcspan wctext001" style="left: 249pt; top: 1.21pt"
                >2</span
              >
              <span class="wcspan wctext001" style="left: 258pt; top: 1.21pt"
                >分)</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 487.4pt; clip: rect(0.5pt, 26.2pt, 49.29pt, 0.25pt)"
          >
            <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
              <span class="wcspan wctext001" style="left: -2pt; top: 32.2pt">
                {{
                  ifet(
                    "D 過去三個月內有沒有受到心理創傷或患上急性疾病?(已預先排定之手術不算)",
                    "0.有",
                    "0"
                  )
                }}
                {{
                  ifet(
                    "D 過去三個月內有沒有受到心理創傷或患上急性疾病?(已預先排定之手術不算)",
                    "2.沒有(沒診所看病而去掛急診者，算沒有給2分)",
                    "2"
                  )
                }}
              </span>
            </div>
          </div>
        </div>
        <div class="wcdiv" style="top: 273.07pt">
          <div
            class="wcdiv"
            style="clip: rect(0.5pt, 487.15pt, 63.89pt, 0.25pt)"
          >
            <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
              <span class="wcspan wctext002" style="left: 0pt; top: 1.21pt"
                >E 精神心理問題</span
              >
            </div>
            <div class="wcdiv" style="left: 16.8pt; top: 16.1pt">
              <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
                >0 = 嚴重痴呆或抑鬱</span
              >
            </div>
            <div class="wcdiv" style="left: 16.8pt; top: 31.7pt">
              <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
                >1 = 輕度痴呆</span
              >
            </div>
            <div class="wcdiv" style="left: 16.8pt; top: 47.29pt">
              <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
                >2 = 沒有精神心理問題</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 487.4pt; clip: rect(0.5pt, 26.2pt, 63.89pt, 0.25pt)"
          >
            <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
              <span class="wcspan wctext001" style="left: -6pt; top: 46.8pt">
                {{ ifet("E 精神心理問題", "0.嚴重痴呆或抑鬱", "0") }}
                {{ ifet("E 精神心理問題", "1.輕度痴呆", "1") }}
                {{ ifet("E 精神心理問題", "2.沒有精神心理問題", "2") }}
              </span>
            </div>
          </div>
        </div>
        <div class="wcdiv" style="top: 335.96pt">
          <div
            class="wcdiv"
            style="clip: rect(0.5pt, 487.15pt, 83.94pt, 0.25pt)"
          >
            <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
              <span class="wcspan wctext002" style="left: 0pt; top: 2.41pt"
                >F1 身體質量指數(BMI) (公斤/米</span
              >
              <span
                class="wcspan wctext002"
                style="font-size: 8pt; left: 177pt; top: 1.98pt"
                >2</span
              >
              <span class="wcspan wctext002" style="left: 181pt; top: 2.41pt"
                >, kg/m</span
              >
              <span
                class="wcspan wctext002"
                style="font-size: 8pt; left: 217pt; top: 1.98pt"
                >2</span
              >
              <span class="wcspan wctext002" style="left: 221pt; top: 2.41pt"
                >)</span
              >
            </div>
            <div class="wcdiv" style="left: 16.8pt; top: 18.8pt">
              <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
                >0 = *** 低於 19</span
              >
            </div>
            <div class="wcdiv" style="left: 16.8pt; top: 34.4pt">
              <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
                >1 = BMI 19</span
              >
              <span class="wcspan wctext001" style="left: 63pt; top: 1.21pt"
                >至低於</span
              >
              <span class="wcspan wctext001" style="left: 102pt; top: 1.21pt"
                >21&nbsp;</span
              >
            </div>
            <div class="wcdiv" style="left: 16.8pt; top: 50pt">
              <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
                >2 = BMI 21</span
              >
              <span class="wcspan wctext001" style="left: 63pt; top: 1.21pt"
                >至低於</span
              >
              <span class="wcspan wctext001" style="left: 102pt; top: 1.21pt"
                >23</span
              >
            </div>
            <div class="wcdiv" style="left: 16.8pt; top: 65.59pt">
              <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
                >3 = BMI 相等或大於 23</span
              >
            </div>
          </div>
          <div
            class="wcdiv"
            style="left: 487.4pt; clip: rect(0.5pt, 26.2pt, 83.94pt, 0.25pt)"
          >
            <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
              <span class="wcspan wctext001" style="left: -6pt; top: 66.85pt">
                {{
                  ifet(
                    "F1 身體質量指數(BMI) (公斤/米2, kg/m2)身高單位換算成公尺，體重單位為公斤\r計算方式：公斤÷公尺÷公尺\r例：160公分，50公斤，取至小數點後一位，以下四捨五入\rBMI為「50公斤÷1.6公尺÷1.6公尺=19.5」\r",
                    "0.BMI 低於 19",
                    "0"
                  )
                }}
                {{
                  ifet(
                    "F1 身體質量指數(BMI) (公斤/米2, kg/m2)身高單位換算成公尺，體重單位為公斤\r計算方式：公斤÷公尺÷公尺\r例：160公分，50公斤，取至小數點後一位，以下四捨五入\rBMI為「50公斤÷1.6公尺÷1.6公尺=19.5」\r",
                    "1.BMI 19至低於21",
                    "1"
                  )
                }}
                {{
                  ifet(
                    "F1 身體質量指數(BMI) (公斤/米2, kg/m2)身高單位換算成公尺，體重單位為公斤\r計算方式：公斤÷公尺÷公尺\r例：160公分，50公斤，取至小數點後一位，以下四捨五入\rBMI為「50公斤÷1.6公尺÷1.6公尺=19.5」\r",
                    "2.BMI 21至低於23",
                    "2"
                  )
                }}
                {{
                  ifet(
                    "F1 身體質量指數(BMI) (公斤/米2, kg/m2)身高單位換算成公尺，體重單位為公斤\r計算方式：公斤÷公尺÷公尺\r例：160公分，50公斤，取至小數點後一位，以下四捨五入\rBMI為「50公斤÷1.6公尺÷1.6公尺=19.5」\r",
                    "3.BMI 相等或大於 23",
                    "3"
                  )
                }}
              </span>
            </div>
          </div>
        </div>
        <div
          class="wcdiv"
          style="
            left: -0.25pt;
            top: 0.5pt;
            width: 0pt;
            height: 418.4pt;
            border-left: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: 487.15pt;
            top: 0.5pt;
            width: 0pt;
            height: 18pt;
            border-left: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: 487.15pt;
            top: 19pt;
            width: 0pt;
            height: 63.39pt;
            border-left: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: 487.15pt;
            top: 82.89pt;
            width: 0pt;
            height: 78.99pt;
            border-left: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: 487.15pt;
            top: 162.38pt;
            width: 0pt;
            height: 62.39pt;
            border-left: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: 487.15pt;
            top: 225.27pt;
            width: 0pt;
            height: 47.79pt;
            border-left: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: 487.15pt;
            top: 273.57pt;
            width: 0pt;
            height: 62.39pt;
            border-left: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: 487.15pt;
            top: 336.46pt;
            width: 0pt;
            height: 82.44pt;
            border-left: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: 513.6pt;
            top: 0.5pt;
            width: 0pt;
            height: 418.4pt;
            border-left: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: -0.25pt;
            top: 0pt;
            width: 514.35pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: 0.25pt;
            top: 18.5pt;
            width: 513.35pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: 0.25pt;
            top: 82.39pt;
            width: 513.35pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: 0.25pt;
            top: 161.88pt;
            width: 513.35pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: 0.25pt;
            top: 224.77pt;
            width: 513.35pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: 0.25pt;
            top: 273.07pt;
            width: 513.35pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: 0.25pt;
            top: 335.96pt;
            width: 513.35pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: -0.25pt;
            top: 418.9pt;
            width: 514.35pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
      </div>
      <div class="wcdiv" style="left: 22pt; top: 516.2pt">
        <span
          class="wcspan wctext001"
          style="font-size: 11pt; left: 0pt; top: 2.96pt"
          >如不能取得身體質量指數(BMI)，請以問題</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 11pt; left: 206.25pt; top: 2.96pt"
          >F2</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 11pt; left: 220pt; top: 2.96pt"
          >代替</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 11pt; left: 244.75pt; top: 2.96pt"
          >F1。如已完成問題</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 11pt; left: 335.5pt; top: 2.96pt"
          >F1，請不要回答問題</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 11pt; left: 437.25pt; top: 2.96pt"
          >F2。</span
        >
      </div>
      <div class="wcdiv" style="left: 19.85pt; top: 539.75pt">
        <div class="wcdiv" style="clip: rect(0.5pt, 490.2pt, 51pt, 0.25pt)">
          <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
            <span class="wcspan wctext002" style="left: 0pt; top: 2.36pt"
              >F2 小腿圍 (CC) (公分, cm)&nbsp;</span
            >
            <span
              class="wcspan wctext002"
              style="font-size: 11pt; left: 156pt; top: 3.16pt"
              >(請量測左腳小腿</span
            >
            <span
              class="wcspan wctext002"
              style="font-size: 11pt; left: 239pt; top: 3.16pt"
              >最粗</span
            >
            <span
              class="wcspan wctext002"
              style="font-size: 11pt; left: 261.5pt; top: 3.16pt"
              >部位，若左腳無法測量才選用右腳替代)</span
            >
            <div
              class="wcdiv"
              style="
                left: 238.5pt;
                top: 1.65pt;
                width: 0pt;
                height: 14.7pt;
                border-left: solid 0.75pt #000000;
              "
            >
              <br />
            </div>
            <div
              class="wcdiv"
              style="
                left: 261pt;
                top: 1.65pt;
                width: 0pt;
                height: 14.7pt;
                border-left: solid 0.75pt #000000;
              "
            >
              <br />
            </div>
            <div
              class="wcdiv"
              style="
                left: 238.5pt;
                top: 1.15pt;
                width: 23pt;
                height: 0pt;
                border-top: solid 0.75pt #000000;
              "
            >
              <br />
            </div>
            <div
              class="wcdiv"
              style="
                left: 238.5pt;
                top: 16.35pt;
                width: 23pt;
                height: 0pt;
                border-top: solid 0.75pt #000000;
              "
            >
              <br />
            </div>
          </div>
          <div class="wcdiv" style="left: 16.8pt; top: 18.8pt">
            <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
              >0 = CC 低於 31</span
            >
          </div>
          <div class="wcdiv" style="left: 16.8pt; top: 34.4pt">
            <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
              >3 = CC 相等或大於 31</span
            >
          </div>
        </div>
        <div
          class="wcdiv"
          style="left: 490.45pt; clip: rect(0.5pt, 28.1pt, 51pt, 0.25pt)"
        >
          <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
            <span class="wcspan wctext001" style="left: 0pt; top: 28.35pt"
              >□</span
            >
          </div>
        </div>
        <div class="wcdiv" style="top: 50pt">
          <div
            class="wcdiv"
            style="clip: rect(0.5pt, 490.2pt, 66.59pt, 0.25pt)"
          >
            <div class="wcdiv" style="left: 5.4pt; top: 0.5pt">
              <span class="wcspan wctext002" style="left: 0pt; top: 2.41pt"
                >篩選分數</span
              >
              <span class="wcspan wctext002" style="left: 96pt; top: 2.41pt"
                >(最高</span
              >
              <span class="wcspan wctext002" style="left: 129pt; top: 2.41pt"
                >14</span
              >
              <span class="wcspan wctext002" style="left: 144pt; top: 2.41pt"
                >分)</span
              >
              <span class="wcspan wctext002" style="left: 168pt; top: 2.41pt"
                >&nbsp;</span
              >
            </div>
            <div class="wcdiv" style="left: 16.8pt; top: 18.8pt">
              <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
                >12-14</span
              >
              <span class="wcspan wctext001" style="left: 33pt; top: 1.21pt"
                >分:</span
              >
              <span class="wcspan wctext001" style="left: 60.6pt; top: 1.21pt"
                >正常營養狀况</span
              >
            </div>
            <div class="wcdiv" style="left: 16.8pt; top: 34.4pt">
              <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
                >8-11</span
              >
              <span class="wcspan wctext001" style="left: 27pt; top: 1.21pt"
                >分:</span
              >
              <span class="wcspan wctext001" style="left: 60.6pt; top: 1.21pt"
                >有營養不良的風險</span
              >
            </div>
            <div class="wcdiv" style="left: 16.8pt; top: 50pt">
              <span class="wcspan wctext001" style="left: 0pt; top: 1.21pt"
                >0-7</span
              >
              <span class="wcspan wctext001" style="left: 21pt; top: 1.21pt"
                >分:</span
              >
              <span class="wcspan wctext001" style="left: 60.6pt; top: 1.21pt"
                >營養不良</span
              >
            </div>
          </div>
        </div>
        <div
          class="wcdiv"
          style="
            left: -0.25pt;
            top: 0.5pt;
            width: 0pt;
            height: 115.09pt;
            border-left: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: 490.2pt;
            top: 0.5pt;
            width: 0pt;
            height: 49.5pt;
            border-left: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: 490.2pt;
            top: 50.5pt;
            height: 65.09pt;
            border-left: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="left: 490.2pt;top: 96pt; height: 20pt; width: 30pt;t"
        >
          {{ score }}
        </div>
        <div
          class="wcdiv"
          style="
            left: 518.55pt;
            top: 0.5pt;
            width: 0pt;
            height: 115.09pt;
            border-left: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: -0.25pt;
            top: 0pt;
            width: 519.3pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: 0.25pt;
            top: 50pt;
            width: 518.3pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
        <div
          class="wcdiv"
          style="
            left: -0.25pt;
            top: 115.59pt;
            width: 519.3pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
      </div>
      <div class="wcdiv" style="left: 14.2pt; top: 655.84pt">
        <span
          class="wcspan wctext001"
          style="font-size: 9pt; left: 0pt; top: 0.9pt"
          >Ref.Vellas B, ******* H, Abellan G, et al.&nbsp;</span
        >
        <span
          class="wcspan wctext006"
          style="font-size: 9pt; left: 193.5pt; top: 0.9pt"
          >Overview of the MNA&reg; - Its History and Challenges</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 9pt; left: 414pt; top: 0.9pt"
          >. J Nutr Health Aging&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 9pt; left: -0.05pt; top: 12.6pt"
          >2006;10:456-465.</span
        >
      </div>
      <div class="wcdiv" style="left: 14.2pt; top: 679.23pt">
        <span
          class="wcspan wctext001"
          style="font-size: 9pt; left: 0pt; top: 0.9pt"
          >Rubenstein LZ, Harker JO, ***** A, Guigoz Y, Vellas B.&nbsp;</span
        >
        <span
          class="wcspan wctext006"
          style="font-size: 9pt; left: 247.5pt; top: 0.9pt"
          >Screening for Undernutrition in Geriatric Practice:&nbsp;</span
        >
        <span
          class="wcspan wctext006"
          style="font-size: 9pt; left: -0.05pt; top: 12.6pt"
          >Developing the Short-Form Mini Nutritional ********** (MNA-SF)</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 9pt; left: 278.95pt; top: 12.6pt"
          >. J. Geront 2001;56A: M366-377.</span
        >
      </div>
      <div class="wcdiv" style="left: 14.2pt; top: 702.63pt">
        <span
          class="wcspan wctext001"
          style="font-size: 9pt; left: 0pt; top: 0.9pt"
          >****** Y. The Mini-Nutritional Assessment (MNA&reg;) Review of the
          Literature - What does it tell us? J **** Health&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 9pt; left: -0.05pt; top: 12.6pt"
          >Aging 2006; 10:466-487. Kaiser MJ, Bauer JM, Ramsch C, et al.
          Validation of the Mini Nutritional Assessment Short-</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 9pt; left: -0.05pt; top: 24.3pt"
          >Form (MNA&reg;-SF): A practical **** for ************** of
          nutritional status. J Nutr Health Aging 2009; 13:782-788.</span
        >
      </div>
      <div class="wcdiv" style="left: 14.2pt; top: 737.72pt">
        <span
          class="wcspan wctext001"
          style="font-size: 9pt; left: 0pt; top: 0.9pt"
          >&reg; Soci&eacute;t&eacute; des Produits Nestl&eacute;, S.A., Vevey,
          Switzerland, Trademark Owners</span
        >
      </div>
      <div class="wcdiv" style="left: 14.2pt; top: 749.42pt">
        <span
          class="wcspan wctext001"
          style="font-size: 9pt; left: 0pt; top: 0.9pt"
          >&copy; Nestl&eacute;, 1994, ******** 2009. N67200 12/99 10M</span
        >
      </div>
      <div class="wcdiv" style="left: 14.2pt; top: 761.12pt">
        <span
          class="wcspan wctext001"
          style="font-size: 9pt; left: 0pt; top: 0.9pt"
          >如需更多資料:&nbsp;</span
        >
        <span
          class="wcspan wctext002"
          style="font-size: 9pt; color: #091c5a; left: 63pt; top: 0.9pt"
          >www.mna-elderly.com</span
        >
        <div
          class="wcdiv"
          style="
            left: 63pt;
            top: 9.7pt;
            width: 85.5pt;
            height: 0pt;
            border-top: solid 0.75pt #091c5a;
          "
        >
          <br />
        </div>
      </div>
    </div>
    <div
      class="wcdiv"
      style="
        left: 278.4pt;
        top: 483.51pt;
        clip: rect(-21.9pt, 261.6pt, 61.54pt, -225.3pt);
      "
    >
      <div
        class="wcdiv"
        style="left: -0.38pt; top: -0.38pt; width: 340px; height: 74px"
      >
        <img
          alt="健檢問卷圖示"
          src="https://myfiles.space/user_files/136203_8f8e61a5d9d46e28/1668417319_2023-new/1668417319_2023-new-4.svg"
        />
      </div>
      <div class="wcdiv" style="clip: rect(3.95pt, 254.05pt, 51.74pt, 0.35pt)">
        <div class="wcdiv" style="left: 7.55pt; top: 3.95pt">
          <span
            class="wcspan wctext001"
            style="font-size: 9pt; left: 0pt; top: 0.9pt"
            >身高單位換算成公尺，體重單位為公斤</span
          >
          <span
            class="wcspan wctext001"
            style="font-size: 9pt; left: 0pt; top: 12.6pt"
            >計算方式：公斤&divide;公尺&divide;公尺</span
          >
          <span
            class="wcspan wctext001"
            style="font-size: 9pt; left: 0pt; top: 24.3pt"
            >例：</span
          >
          <span
            class="wcspan wctext001"
            style="font-size: 9pt; left: 18pt; top: 24.3pt"
            >160</span
          >
          <span
            class="wcspan wctext001"
            style="font-size: 9pt; left: 33.75pt; top: 24.3pt"
            >公分，</span
          >
          <span
            class="wcspan wctext001"
            style="font-size: 9pt; left: 60.75pt; top: 24.3pt"
            >50</span
          >
          <span
            class="wcspan wctext001"
            style="font-size: 9pt; left: 72pt; top: 24.3pt"
            >公斤，取至小數點後一位，以下四捨五入</span
          >
          <span
            class="wcspan wctext001"
            style="font-size: 9pt; left: 0pt; top: 36pt"
            >BMI</span
          >
          <span
            class="wcspan wctext001"
            style="font-size: 9pt; left: 15.75pt; top: 36pt"
            >為「</span
          >
          <span
            class="wcspan wctext001"
            style="font-size: 9pt; left: 33.75pt; top: 36pt"
            >50</span
          >
          <span
            class="wcspan wctext001"
            style="font-size: 9pt; left: 45pt; top: 36pt"
            >公斤&divide;</span
          >
          <span
            class="wcspan wctext001"
            style="font-size: 9pt; left: 67.5pt; top: 36pt"
            >1.</span
          >
          <span
            class="wcspan wctext001"
            style="font-size: 9pt; left: 76.5pt; top: 36pt"
            >6</span
          >
          <span
            class="wcspan wctext001"
            style="font-size: 9pt; left: 83.25pt; top: 36pt"
            >公尺&divide;</span
          >
          <span
            class="wcspan wctext001"
            style="font-size: 9pt; left: 105.75pt; top: 36pt"
            >1.</span
          >
          <span
            class="wcspan wctext001"
            style="font-size: 9pt; left: 114.75pt; top: 36pt"
            >6</span
          >
          <span
            class="wcspan wctext001"
            style="font-size: 9pt; left: 121.5pt; top: 36pt"
            >公尺</span
          >
          <span
            class="wcspan wctext001"
            style="font-size: 9pt; left: 139.5pt; top: 36pt"
            >=19.5</span
          >
          <span
            class="wcspan wctext001"
            style="font-size: 9pt; left: 162pt; top: 36pt"
            >」</span
          >
        </div>
      </div>
    </div>
    <div class="wcdiv">
      <img
        class="wcimg"
        style="left: 448.45pt; top: 49.9pt; width: 117.95pt; height: 22.85pt"
        src="https://health-examination.tncghb.gov.tw/images/nestle.png"
        width="117.95pt"
        height="22.85pt"
      />
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import MixinBigQuiz from "@/mixins/bigQuiz";
import "@/assets/bigQuiz.scss";
export default {
  props: ["person"],
  mixins: [MixinBigQuiz],
  computed: {
    score() {
      return (
        parseInt(
          this.ifet(
            "A 過去三個月內有沒有因為食慾不振、消化問題、咀嚼或吞嚥困難而減少食量?",
            "0 .食量嚴重減少(如一個便當本來吃的完，現在只吃1/2為少很多)",
            "0"
          ) * 1
        ) +
        parseInt(
          this.ifet(
            "A 過去三個月內有沒有因為食慾不振、消化問題、咀嚼或吞嚥困難而減少食量?",
            "1.食量中度減少 (如一個便當本來吃的完，現在只吃2/3為少一點)",
            "1"
          ) * 1
        ) +
        parseInt(
          this.ifet(
            "A 過去三個月內有沒有因為食慾不振、消化問題、咀嚼或吞嚥困難而減少食量?",
            "2.食量沒有改變",
            "2"
          ) * 1
        ) +
        parseInt(
          this.ifet(
            "B 過去三個月內體重下降的情況",
            "0.體重下降大於3公斤 (6.6磅)",
            "0"
          ) * 1
        ) +
        parseInt(
          this.ifet("B 過去三個月內體重下降的情況", "1.不知道", "1") * 1
        ) +
        parseInt(
          this.ifet(
            "B 過去三個月內體重下降的情況",
            "2.體重下降1-3公斤 (2.2-6.6磅)",
            "2"
          ) * 1
        ) +
        parseInt(
          this.ifet("B 過去三個月內體重下降的情況", "3.體重沒有下降", "3") * 1
        ) +
        parseInt(this.ifet("C 活動能力", "0.需長期臥床或坐輪椅", "0") * 1) +
        parseInt(
          this.ifet("C 活動能力", "1.可以下床或離開輪椅，但不能外出", "1") * 1
        ) +
        parseInt(this.ifet("C 活動能力", "2.可以外出", "2") * 1) +
        parseInt(
          this.ifet(
            "D 過去三個月內有沒有受到心理創傷或患上急性疾病?(已預先排定之手術不算)",
            "0.有",
            "0"
          ) * 1
        ) +
        parseInt(
          this.ifet(
            "D 過去三個月內有沒有受到心理創傷或患上急性疾病?(已預先排定之手術不算)",
            "2.沒有(沒診所看病而去掛急診者，算沒有給2分)",
            "2"
          ) * 1
        ) +
        parseInt(this.ifet("E 精神心理問題", "0.嚴重痴呆或抑鬱", "0") * 1) +
        parseInt(this.ifet("E 精神心理問題", "1.輕度痴呆", "1") * 1) +
        parseInt(this.ifet("E 精神心理問題", "2.沒有精神心理問題", "2") * 1) +
        parseInt(
          this.ifet(
            "F1 身體質量指數(BMI) (公斤/米2, kg/m2)身高單位換算成公尺，體重單位為公斤\r計算方式：公斤÷公尺÷公尺\r例：160公分，50公斤，取至小數點後一位，以下四捨五入\rBMI為「50公斤÷1.6公尺÷1.6公尺=19.5」\r",
            "0.BMI 低於 19",
            "0"
          ) * 1
        ) +
        parseInt(
          this.ifet(
            "F1 身體質量指數(BMI) (公斤/米2, kg/m2)身高單位換算成公尺，體重單位為公斤\r計算方式：公斤÷公尺÷公尺\r例：160公分，50公斤，取至小數點後一位，以下四捨五入\rBMI為「50公斤÷1.6公尺÷1.6公尺=19.5」\r",
            "1.BMI 19至低於21",
            "1"
          ) * 1
        ) +
        parseInt(
          this.ifet(
            "F1 身體質量指數(BMI) (公斤/米2, kg/m2)身高單位換算成公尺，體重單位為公斤\r計算方式：公斤÷公尺÷公尺\r例：160公分，50公斤，取至小數點後一位，以下四捨五入\rBMI為「50公斤÷1.6公尺÷1.6公尺=19.5」\r",
            "2.BMI 21至低於23",
            "2"
          ) * 1
        ) +
        parseInt(
          this.ifet(
            "F1 身體質量指數(BMI) (公斤/米2, kg/m2)身高單位換算成公尺，體重單位為公斤\r計算方式：公斤÷公尺÷公尺\r例：160公分，50公斤，取至小數點後一位，以下四捨五入\rBMI為「50公斤÷1.6公尺÷1.6公尺=19.5」\r",
            "3.BMI 相等或大於 23",
            "3"
          ) * 1
        )
      );
    },
    age() {
      let birth = this.person.出生年月日 + 19110000 + "";
      let year = dayjs(birth).get("year");
      let thisYear = dayjs().get("year");
      return thisYear - year;
      // let birth = parseInt(this.person.出生年月日) + 19110000 + "";
      // let age = dayjs().diff(birth, "year");
      // return age;
    },
    性別() {
      switch (this.person.身分證字號[1]) {
        case "1":
        case "A":
        case "C":
          return "男";
          break;
        case "2":
        case "B":
        case "D":
          return "女";
          break;
      }
    },
  },
};
</script>
